export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/gangjin-6d2d60c609b897d758e8c553fda0e829.png";